import * as React from "react";
import {PremiumType} from "@falcon/services";
import {MtaSuccessModalWording} from "../../../../common/modal/MtaSuccessModalWording";
import {IFactors} from "../../../../common/modal/GeneratorInputTypes";
import {EditCarMtaSuccessModalWordingGenerator} from "./EditCarMtaSuccessModalWordingGenerator";
import * as successModals from "../../../../../../components/modals/SuccessModalRenderers";
import {paymentPlanUpdatedAdditionalPremiumModal} from "../../../../../../components/modals/SuccessModalRenderers";

export interface IUiState {
    payFullPrice: boolean,
    removedDriverFullName: string;
}

export class RemoveDriverMtaSuccessModalWordingGenerator {

    public static readonly generateModalWording = (factors: IFactors, uistate: IUiState, cardNumber: string, agreeToReuseCardDetails: boolean, previousMonthlyPremium: any, instalmentsNotPaidOff: boolean): MtaSuccessModalWording => {

        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        let modalTitle: React.ReactNode;
        let modalBody: React.ReactNode;

        if (factors.additionalPremium > 0 && (premiumType === PremiumType.annual || uistate.payFullPrice)) {
            modalTitle = "Payment was successful";
            const modalBodyContent = (
                <>
                    for <span className="font-weight-semi-bold">removing {uistate.removedDriverFullName} from your car policy.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumModal(factors.additionalPremium, cardNumber, modalBodyContent, agreeToReuseCardDetails);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount && !uistate.payFullPrice) {
            // TODO: upfront payment comparison scenarios are not handled. Bug?:
            //  factors.additionalPremium > 0 && factors.upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !payFullPrice
            //  factors.additionalPremium > 0 && factors.upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !payFullPrice
            // TODO: "Your future monthly payments will be" is missing. Intentional?
            modalTitle = "Payment was successful";
            const modalContent = (
                <>
                    for <span className="font-weight-semi-bold">removing {uistate.removedDriverFullName} from your car policy.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumMonthlyModal(factors.upfrontPaymentAmount, factors.monthlyPaymentSpreadAmount, cardNumber, modalContent, agreeToReuseCardDetails);
        } else if (factors.returnPremium > 0 && premiumType === PremiumType.monthly && factors.monthlyPremium !== 0) {
            if (instalmentsNotPaidOff) {
                modalTitle = "Your payment plan has been updated";
            } else {
                modalTitle = "Your refund is on the way";
            }
            modalBody = successModals.paymentPlanUpdatedRefundModal(factors.returnPremium, factors.monthlyPremium, previousMonthlyPremium, instalmentsNotPaidOff);
        } else if (factors.returnPremium > 0) {
            modalTitle = "Your Refund is on the way";
            const modalContent = (
                <>
                    <span className="font-weight-semi-bold">for removing {uistate.removedDriverFullName} from your car policy.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulRefundModal(factors.returnPremium, modalContent);
        } else {
            modalTitle = "Change was successful";
            modalBody = (<>
                    <p className="font-weight-extra-light">
                        We’ve removed {uistate.removedDriverFullName} from your car policy.
                    </p>
                    {paymentPlanUpdatedAdditionalPremiumModal(factors, previousMonthlyPremium)}
                </>
            );
        }

        return new MtaSuccessModalWording(modalTitle, modalBody, EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle(), EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody());
    }

}
